import React from 'react';
import ReactDOM from 'react-dom/client';
import "./shared/styles/reset.css"
import "./shared/styles/theme-tokens.css";
import "./shared/styles/reveal.css";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);